@if (data?.isSuccess) {
  <div class="success-icon">
    <mat-icon>check</mat-icon>
  </div>
} @else {
  <div class="error-icon">
    <img ngSrc="assets/sad-bottle.png" width="51" height="100" alt="Sad bottle"/>
  </div>
}

@if (data?.message) {
  <p class="text-center">{{data?.message}}</p>
}

<div class="flex justify-center gap-4">
  @if (data?.closeButtonText) {
    <button mat-flat-button (click)="closeModal()" class="btn-grey">{{data?.closeButtonText}}</button>
  }
  @if (data?.actionButtonText) {
    <button mat-flat-button (click)="runAction()">{{data?.actionButtonText}}</button>
  }
</div>
